import { render, staticRenderFns } from "./RegulationExemptionRow.vue?vue&type=template&id=80764d28&scoped=true&"
import script from "./RegulationExemptionRow.vue?vue&type=script&lang=js&"
export * from "./RegulationExemptionRow.vue?vue&type=script&lang=js&"
import style0 from "./RegulationExemptionRow.vue?vue&type=style&index=0&id=80764d28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80764d28",
  null
  
)

export default component.exports